import React from "react";

const Help = ({ helpContent, differentStyle, helpHeadline }) => {
  return (
    <section className={`m-help ${differentStyle ? differentStyle : ""}`}>
      <div className="_wr">
        <div className="m-help__topContent">
          <h2 className="m-help__topContent--title">{helpHeadline}</h2>
          <span className="a-line -red"></span>
        </div>
        <div className="_w m-help__cardsContainer">
          {helpContent.map(({ img, title, textOne, textTwo, textThree }, i) => (
            <div className="_l6 m-help__cardContent" key={i}>
              <div className="m-help__card">
                <div className="m-help__card--imageTitle">
                  <div className="m-help__card--image">{img}</div>
                  <h3 className="m-help__card--title">{title}</h3>
                </div>
                <div className="m-help__card--textContainer">
                  <p className={`m-help__card--text ${textTwo ? "" : "-solo"}`}>
                    {textOne}
                  </p>
                  {textTwo ? (
                    <p className="m-help__card--text">{textTwo}</p>
                  ) : (
                    ""
                  )}
                  {textThree ? (
                    <p className="m-help__card--text">{textThree}</p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Help;
